// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e94afa96","239":"5e281eab","455":"19fd2c41"}[chunkId] + ".chunk.js";
};